module.exports = __webpack_public_path__ + "84fcfe89f573be508946d04c15a82399.svg";